// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-text {
  position: relative;
}
.dialog-text__hint {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-1-font-size);
  line-height: var(--g-text-body-1-line-height);
  color: var(--g-color-text-secondary);
  margin-top: 10px;
}
.dialog-text__checkbox {
  margin-block-start: var(--g-spacing-2);
}
.dialog-text__row {
  margin-bottom: var(--g-spacing-2);
}
.dialog-text__row:last-child {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/DialogTextWidget/DialogTextWidget.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;AADJ;AAGI;ECkKA,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;EDnKI,oCAAA;EACA,gBAAA;AAER;AACI;EACI,sCAAA;AACR;AAEI;EACI,iCAAA;AAAR;AAEQ;EACI,gBAAA;AAAZ","sourcesContent":[".dialog-text {\n  position: relative;\n}\n.dialog-text__hint {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-1-font-size);\n  line-height: var(--g-text-body-1-line-height);\n  color: var(--g-color-text-secondary);\n  margin-top: 10px;\n}\n.dialog-text__checkbox {\n  margin-block-start: var(--g-spacing-2);\n}\n.dialog-text__row {\n  margin-bottom: var(--g-spacing-2);\n}\n.dialog-text__row:last-child {\n  margin-bottom: 0;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
